import {computed} from "vue";
import {PageDataHolderFetchedWidget} from "../../lib/interfaces/model/PageDataHolderFetchedWidget";
import {
    obtainActiveLocale,
    obtainActiveLocaleCurrency,
    obtainActiveWebCountry,
    useTyrionMasterPage
} from "../master_page";
import {Widget} from "../../lib/interfaces/model/Widget";
import Accommodation from "../../lib/models/Accommodation";
import {getCurrentUser} from "../auth/useAuthUser";

export function useWidget(widget: PageDataHolderFetchedWidget) {


    const content = computed<Array<Accommodation>>(() => widget.content.map((t: { [k: string]: any }) => (new Accommodation()).fromObject(t)));
    const activeLocale = obtainActiveLocale();
    const activeLocaleCurrency = obtainActiveLocaleCurrency();
    const activeCountry = obtainActiveWebCountry();

    return {
        content: content.value as Array<Accommodation>,
        widgetData: widget.widget as Widget,
        client: getCurrentUser(),
        masterPage: useTyrionMasterPage(),
        activeLocale: activeLocale as { code: String, name: String, iso: String },
        activeCountry: activeCountry as { code: String, name: String },
        activeLocaleCurrency: activeLocaleCurrency as { code: String, name: String, mark: String },
    };
}
